var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      attrs: {
        src: require(`.././../../assets/images/upgrade-now@2x.png`),
        srcset: `${require(`../../../assets/images/upgrade-now@1x.png`)} 1x, ${require(`../../../assets/images/upgrade-now@2x.png`)} 2x, ${require(`../../../assets/images/upgrade-now@3x.png`)} 3x, ${require(`../../../assets/images/upgrade-now@4x.png`)} 4x`,
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-body d-flex gap-20" }, [
      _c("div", { staticClass: "d-flex flex-column gap-10" }, [
        _c("h2", { staticClass: "modal-title" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm._f("trans")("Not Enough Credits Left")) +
              "\n                "
          ),
          _c("div", { staticClass: "icon-box" }, [
            _c("strong", { staticClass: "d-flex align-items-center" }, [
              _vm._v("!"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-end" },
              [_c("CoinSVG")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-text" }, [
          _c("p", [
            _vm._v(
              _vm._s(_vm._f("trans")("But don't worry, here are your options:"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.getUpgradeText, function (text) {
              return _c("li", { domProps: { innerHTML: _vm._s(text) } })
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }